import i18n from 'i18next';

import axios, {AxiosResponse} from "axios";
import {toast} from "react-toastify";

import store from "store/store";
import {logout} from "store/modules/users/authReducer";
import config from "config/config";

const BLOCKED_ACCOUNT_MESSAGE =
    "החשבון שלך נחסם לאחר מספר ניסיונות שגויים. יש ליצור קשר עם מנהל המערכת: 073-3701564 | https://www.proxibit.co.il/#contact";

export const configureAxiosErrorHandler = () => {

    axios.defaults.baseURL = config.APP_API_URL;

    axios.interceptors.response.use(undefined, error => {

        // console.log(error,error.response);

        if (error.message === 'Network Error' && !error.response) {
            toast.error(i18n.t("connection_to_the_server_lost_reconnecting_string"));
        }

        // console.log(error.response);

        const {status, data, config} = error.response;

        if (error.status === 413) {
            toast.error(i18n.t("the_file_you_are_trying_to_upload_exceeds_the_maximum_size"));
        }

        if (status === 404) {
            toast.error(i18n.t("invalid_login_or_password_string"));
        }

        if (status === 409) {
            toast.error(i18n.t("your_account_is_alerady_verified"));
            store.dispatch(logout());
        }

        if (status === 410) {
            toast.error(data.message);
        }

        if (status === 402) {
            toast.error(i18n.t("someone_initiated_the_password_recovery_string"));
        }

        if (status === 423) {
            const blockedMessage = data?.message || data?.error || BLOCKED_ACCOUNT_MESSAGE;
            let s = store.getState();
            if (s.router?.location?.pathname !== '/login') {
                toast.error(blockedMessage);
            }
        }

        if (status === 403) {
            let s = store.getState();
            if(s.router?.location?.pathname == '/reset-password') {
                toast.error(i18n.t("there_is_no_account_for_this_email_string"))
            }
            else {
                toast.error(i18n.t("invalid_confirmation_code_string"))
            }
        }

        if (status === 401) {
            let s = store.getState();
            if(s.router?.location?.pathname !== '/login'){
                toast.error(i18n.t("your_session_expired_please_re_login_string"));
                store.dispatch(logout());
                window.location.reload();
            }
        }

        if (status === 426) {
            // console.log('dss')
            // updateUserToken();
            // // let s = store.getState();
            // // if(s.router?.location?.pathname !== '/login'){
            // //     store.dispatch(logout());
            // // }
        }

        if (status === 500) {
            toast.error(i18n.t("something_went_wrong_string"));
        }

        if (status === 400) {
            let message = data.message
            switch(message) {
                case 'Forbidden':
                    message = i18n.t("it_is_not_allowed_to_have_more_than_one_unapproved_request")
                    break
                case 'PORTFOLIO_MAX_INDEX_NUMBER':
                    message = i18n.t("forbidden_portfolio_max_index_number_error")
                    break;
                case 'PORTFOLIO_MIN_INDEX_WEIGHT':
                    message = i18n.t("forbidden_portfolio_min_index_weight_error")
                    break;
                case 'PORTFOLIO_MIN_NEW_INDEX_VALUE':
                    message = i18n.t("forbidden_portfolio_min_index_weight_error")
                    break;
                case 'CUSTOM_INDEX_MAX_COIN_NUMBER':
                    message = i18n.t("forbidden_custom_index_max_coin_number_error")
                    break;
                case 'CUSTOM_INDEX_MIN_COIN_WEIGHT':
                    message = i18n.t("forbidden_custom_index_min_coin_weight_error")
                    break;
                case 'CUSTOM_INDEX_MIN_UPDATED_COIN_WEIGHT':
                    message = i18n.t("forbidden_custom_index_min_coin_weight_error")
                    break;
                case 'Sum of coin weights must be 100.':
                    message = i18n.t("forbidden_sum_of_coin_weights_must_be_100_error")
                    break;
                case 'Sum of weights of indexes must be 100.':
                    message = i18n.t("forbidden_sum_of_weights_of_indexes_must_be_100_error")
                    break;
                case 'No portfolio':
                    message = i18n.t("forbidden_not_allowed_to_create_operation_if_portfolio_is_not_defined_error")
                    break;
                case 'FIRST_DEPOSIT_MIN_NIS_AMOUNT':
                    message = i18n.t("forbidden_first_deposit_min_nis_amount_error")
                    break;
                case 'DEPOSIT_MIN_NIS_AMOUNT':
                    message = i18n.t("forbidden_deposit_min_nis_amount_error")
                    break;
                case 'DEPOSIT_MIN_INDEX_VALUE':
                    message = i18n.t("forbidden_deposit_min_index_value_error")
                    break;
                case 'WITHDRAWAL_MIN_NIS_AMOUNT':
                    message = i18n.t("forbidden_withdrawal_min_nis_amount_error")
                    break;
            }
            toast.error(message)
        }

        return Promise.reject(error);
    });
}
